import { createReducer, on } from '@ngrx/store';
import * as AppSettingsActions from './app-settings.actions';
import { initialAppSettingsState } from './app-settings.state';

export const appSettingsReducer = createReducer(
  initialAppSettingsState,

  on(AppSettingsActions.loadSettings, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AppSettingsActions.loadSettingsSuccess, (state, { settings }) => ({
    ...state,
    settings,
    loading: false,
    error: null,
  })),

  on(AppSettingsActions.loadSettingsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(AppSettingsActions.updateSetting, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AppSettingsActions.updateSettingSuccess, (state, { setting }) => ({
    ...state,
    settings: state.settings.map(item => item.key === setting.key ? setting : item),
    loading: false,
    error: null,
  })),

  on(AppSettingsActions.updateSettingFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);
